<template>
  <v-row justify="end" class="mr-0">
    <v-dialog persistent v-model="detailsDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t(translation+'.details')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-on:submit.prevent>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="data.name"
                    :label="$t(translation+'.name')+'*'" required
                    readonly
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="data.type"
                    :label="$t(translation+'.name')+'*'" required
                    readonly
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12" v-if="data.page_content_details != null">
                  Sadržaj stranice
                  <div style="border: 1px solid grey; border-radius: 5px; padding: 10px" v-html="data.page_content_details"/>
                </v-col>
                <v-col cols="12" v-if="type.id === 3">
                  <v-text-field
                    v-model="data.available_dates"
                    :label="'Datumi'"
                    readonly
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12">
                  <v-img v-if="dataForModal != null && detailsDialog" :src="'/api/images/sliders/'+dataForModal.image"/>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{$t('required_fields')}}</small>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text :disabled="loading" @click="closeDialog">{{$t('close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
  import {add, readCategoriesActive, addEmit} from "../../statics/DataTableFunctions";
  import ckeditor from "../../../node_modules/ckeditor4-vue/dist/ckeditor.js"
  import axios from 'axios'

  export default {
    props: {
      detailsDialog: false,
      dataForModal: null,
    },
    name: "DetailsDialog",
    data() {
      return {
        translation: 'sliders',
        api: 'sliders',
        type: {id: 1},
        types: [
          {id: 1, value: 'Slika'},
          {id: 2, value: 'Promocija'},
          {id: 3, value: 'Seminar'},
        ],
        data: {
          name: '',
          type: '',
          available_dates: '',
          notification_text: '',
          page_content: '',
          page_content_details: '',
          image: '',
        },
        loading: false,
        snackbar: {
          color: 'success',
          show: false,
          text: '',
          timeout: 3000,
        },
      }
    },
    methods: {
      readCategoriesActive,
      closeDialog() {
        this.type = {"id": 1};
        this.data = {
          name: '',
          type: '',
          available_dates: '',
          notification_text: '',
          page_content: '',
          page_content_details: '',
          image: '',
        }
        this.$emit('close');
      }
    },
    watch: {
      detailsDialog: function (val) {
        if (val) {
          for (let i = 0; i < this.types.length; i++) {
            if (this.types[i].value === this.dataForModal.type) {
              this.type = this.types[i];
            }
          }
          this.data = {
            name: this.dataForModal.name,
            type: this.dataForModal.type,
            image: this.dataForModal.image,
            page_content: this.dataForModal.page_content,
            available_dates: this.dataForModal.available_dates,
            notification_text: this.dataForModal.notification_text,
            page_content_details: this.dataForModal.page_content_details,
          }
        }
      },
    }
  }
</script>

<style scoped/>
